// apps/web/src/api/client.ts
import { VisitorsService } from './services/visitors.service';
import { VisitsService } from './services/visits.service';
import { AuthService } from './services/auth.service';
import { environment } from '../config/environment';
import { SubscriptionsService } from './services/subscriptions.service';
import {
  CreateVisitorRequest,
  UpdateVisitorRequest,
  VisitorWithSubscription,
} from '@gym-management/shared';

class ApiClient {
  public visitors: VisitorsService;
  public visits: VisitsService;
  public auth: AuthService;
  public subscriptions: SubscriptionsService;

  constructor() {
    this.visitors = new VisitorsService();
    this.visits = new VisitsService();
    this.auth = new AuthService();
    this.subscriptions = new SubscriptionsService();
  }

  get baseUrl(): string {
    return environment.apiBaseUrl;
  }

  // Прокси-методы с правильными типами
  async getAllVisits(page?: number, limit?: number, date?: string) {
    return this.visits.getAllVisits(page, limit, date);
  }
  async getVisitor(id: string): Promise<VisitorWithSubscription> {
    return this.visitors.getVisitor(id);
  }
  async getVisitors(page?: number, limit?: number, search?: string, active?: boolean | null) {
    return this.visitors.getVisitors(page, limit, search, active);
  }

  async getDailyStats(date?: string) {
    return this.visits.getDailyStats(date);
  }

  async createVisitor(data: CreateVisitorRequest) {
    return this.visitors.createVisitor(data);
  }

  async updateVisitor(id: string, data: UpdateVisitorRequest) {
    return this.visitors.updateVisitor(id, data);
  }

  async deleteVisitor(id: string) {
    return this.visitors.deleteVisitor(id);
  }

  async getVisitorStats(search?: string) {
    return this.visitors.getVisitorStats(search);
  }

  async checkIn(visitorId: string) {
    return this.visits.checkIn(visitorId);
  }

  async checkOut(visitId?: string, visitorId?: string) {
    return this.visits.checkOut(visitId, visitorId);
  }

  async getActiveVisits(page?: number, limit?: number) {
    return this.visits.getActiveVisits(page, limit);
  }

  async login(email: string, password: string) {
    return this.auth.login(email, password);
  }

  logout() {
    this.auth.logout();
  }

  getToken() {
    return this.auth.getToken();
  }

  async getSubscriptionTypes() {
    return this.subscriptions.getSubscriptionTypes();
  }

  async getAllActiveSubscriptions() {
    return this.subscriptions.getAllActiveSubscriptions();
  }

  // ✅ НОВЫЙ МЕТОД: продление / обновление подписки
  async renewSubscription(data: {
    visitorId: string;
    newSubscriptionTypeId: string;
    action: 'extend' | 'upgrade';
  }) {
    return this.subscriptions.renewSubscription(data);
  }
}

export const apiClient = new ApiClient();
export default apiClient;
